/**
 * @fileoverview General utility functions for the frontend.
 * Provides common utilities used throughout the application,
 * including className merging for Tailwind CSS.
 * @module lib/utils
 */

import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

/**
 * Merges class names using clsx and tailwind-merge.
 * Combines conditional classes and resolves Tailwind CSS conflicts.
 * @param inputs - Class values to merge (strings, objects, arrays)
 * @returns Merged className string with conflicts resolved
 * @example
 * cn("px-2 py-1", "px-4") // "py-1 px-4"
 * cn("text-red-500", condition && "text-blue-500")
 */
export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}
